





































import { Component, Vue } from 'vue-property-decorator';

import Logo from '@/components/Logo/Logo.vue';

@Component({
  components: {
    Logo,
  },
  name: 'SplashScreen',
})
export default class SplashScreen extends Vue {
  login(): void {
    this.$auth.loginWithRedirect({});
  }
}
